var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 14.9896L13.8228 17.6042C14.6145 18.0833 15.5833 17.375 15.3749 16.4792L14.2291 11.5625L18.052 8.24999C18.7499 7.64582 18.3749 6.49999 17.4583 6.42707L12.427 5.99999L10.4583 1.35416C10.1041 0.510406 8.89576 0.510406 8.54159 1.35416L6.57284 5.98957L1.54159 6.41666C0.624923 6.48957 0.249923 7.63541 0.94784 8.23957L4.77076 11.5521L3.62492 16.4687C3.41659 17.3646 4.38534 18.0729 5.17701 17.5937L9.49992 14.9896Z",
    fill: "#FFB923"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSelection);
export default __webpack_public_path__ + "static/media/star_selection.f90126d19ac988ae15e969c3705e4cbd.svg";
export { ForwardRef as ReactComponent };